<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import { t } from "../../helpers/translation";
</script>

<LightTheme />

<Hero headline={$t("page.associations.hero.headline")} small gray />

<Container>
    <Headline>
        {@html $t("page.associations.headline")}
    </Headline>
    <Subline>
        {@html $t("page.associations.subline")}
    </Subline>

    <Gap height="4rem" />

    <div class="verbaende">
        <Image
            src="https://liveicom.azureedge.net/sinus/img/verbaende/Bundesverband_Professioneller_Mobilfunk_Logo.svg"
        />
        <Image
            src="https://liveicom.azureedge.net/sinus/img/verbaende/lfv-sh.svg"
        />
        <Image
            src="https://liveicom.azureedge.net/sinus/img/verbaende/Landesfeuerwehrverband-Niedersachsen.svg"
        />
    </div>
</Container>

<style lang="scss">
    @import "./src/vars";

    .verbaende {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        gap: 5em;
    }
</style>
